// eslint-disable-next-line react/prop-types

import React, { useState } from "react";
import OTPInput from "react-otp-input";
import PropTypes from "prop-types";

const MyOtp = ({ ...props }) => {
  const handleChange = (value) => {
    props?.onChange(value);
  };

  return (
    <div className="d-flex justify-content-center">
      <OTPInput
        value={props.value}
        onChange={handleChange}
        numInputs={props.numInputs}
        inputStyle={{
          width: "40px",
          height: "40px",
          margin: "0 5px",
          fontSize: "18px",
          borderRadius: "4px",
          border: "1px solid #ccc",
        }}
        renderInput={(props) => <input {...props} />}
      />
    </div>
  );
};

MyOtp.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  numInputs: PropTypes.number,
};

export default MyOtp;
